@if (content) {
  <div
    class="cx-card"
    [class.cx-card-border]="border"
    [class.cx-card-fit-to-container]="fitToContainer"
    >
    <!-- Card Header -->
    @if (content.header && !editMode) {
      <div class="card-header">
        <div class="header-icon">
          <!-- <cx-icon [type]="iconType.CHECK_CIRCLE_FILLED"></cx-icon> -->
          <img src="icons/message-bar-success.svg">
        </div>
        <div class="header-text">
          {{ 'efaAddressBook.defaultAddress' | cxTranslate }}
        </div>
      </div>
    }
    <!-- Card Body -->
    <div class="card-body cx-card-body" [class.cx-card-delete]="editMode">
      <!-- Edit message -->
      @if (editMode) {
        <div class="cx-card-delete-msg">
          {{ content.deleteMsg }}
        </div>
      }
      <!-- Card title -->
      @if (content.title) {
        <h3 class="cx-card-title">
          {{ content.title }}
        </h3>
      }
      <!-- Card Content -->
      <div class="cx-card-container">
        <!-- Card Label -->
        <div class="cx-card-label-container">
          @if (content.textBold) {
            <div class="cx-card-label-bold">
              {{ content.textBold }}
            </div>
          }
          @for (line of content.text; track line) {
            <div>
              @if (!truncateText) {
                <div class="cx-card-label">
                  {{ line }}
                </div>
              } @else {
                <cx-truncate-text-popover
                  [charactersLimit]="charactersLimit"
                  [content]="line"
                ></cx-truncate-text-popover>
              }
            </div>
          }
          @for (item of content.paragraphs; track item) {
            <div class="cx-card-paragraph">
              <div class="cx-card-paragraph-title">{{ item.title }}</div>
              @for (text of item.text; track text) {
                <div>
                  <div class="cx-card-paragraph-text">
                    {{ text }}
                  </div>
                </div>
              }
            </div>
          }
        </div>
        <!-- Image -->
        @if (content.img) {
          <div class="cx-card-img-container">
            <cx-icon [type]="content.img"></cx-icon>
          </div>
        }
      </div>
      <!-- Edit Mode Actions -->
      @if (editMode) {
        <div class="row cx-card-body-delete">
          <div class="col-md-6">
            <button class="btn btn-block btn-secondary" (click)="cancelEdit()">
              {{ 'common.cancel' | cxTranslate }}
            </button>
          </div>
          <div class="col-md-6">
            <button class="btn btn-block btn-primary" (click)="delete()">
              {{ 'common.delete' | cxTranslate }}
            </button>
          </div>
        </div>
      }
      <!-- Actions -->
      @if (content.actions && !editMode) {
        <div class="cx-card-actions">
          @for (action of content.actions; track action) {
            <div>
              <div>
                @switch (action.event) {
                  @case ('delete') {
                    <a
                      class="cx-card-link card-link btn-link cx-action-link"
                      (click)="delete()"
                      (keydown.enter)="delete()"
                      tabindex="0"
                      >{{ action.name }}</a
                      >
                    }
                    @case ('default') {
                      <a
                        class="cx-card-link card-link btn-link cx-action-link"
                        (click)="setDefault()"
                        (keydown.enter)="setDefault()"
                        tabindex="0"
                        >{{ action.name }}</a
                        >
                      }
                      @case ('send') {
                        <a
                          class="cx-card-link card-link btn-link cx-action-link"
                          (click)="send()"
                          (keydown.enter)="send()"
                          tabindex="0"
                          >{{ action.name }}</a
                          >
                        }
                        @case ('edit') {
                          <a
                            class="cx-card-link card-link btn-link cx-action-link"
                            (click)="edit()"
                            (keydown.enter)="edit()"
                            tabindex="0"
                            >{{ action.name }}</a
                            >
                          }
                          @default {
                            <a
                              href="{{ action.link }}"
                              class="card-link btn-link cx-action-link"
                              tabindex="0"
                              >{{ action.name }}</a
                              >
                            }
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
